import AjaxUtility from "../../../../../ig_template/Resources/Public/Src/Js/Utility/AjaxUtility";

$(document).ready(function () {
	const container = $('.tx-ig-magicline-occupancy'),
		location = parseInt(container.data('location'));

	if(container.length > 0) {
		AjaxUtility.request(4952, {action: 'utilization', location: location}, {
			4952: 'tx_igmagiclineoccupancy_occupancy'
		})
			.done(response => {
				$('.tx-ig-magicline-occupancy').html(response);

				const $equalizerRow = $('.tx-ig-magicline-occupancy').closest('.row[data-equalizer]');

				if ($equalizerRow.length) {
					new Foundation.Equalizer($equalizerRow).applyHeight();
				}
			});
	}
});
